import type { RouteObject } from "react-router-dom";
import RoleMatrixEditor from "./Editor";
import AppError from "../app-error";

export const roleMatrixRoutes: RouteObject[] = [
  { path: "role-matrix", Component: RoleMatrixEditor, errorElement: <AppError /> },
];
